import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { useThemeColors } from '@/hooks/useThemeColors';
import { TruckForm } from '@/components/forms/TruckForm'; 

export default function CreateTruckPage() {
    const colors = useThemeColors();
    const navigate = useNavigate();
    
    const handleSuccess = () => {
        navigate('/fleet-management/trucks');
    };

    const handleCancel = () => {
        navigate('/fleet-management/trucks');
    };

    return (
        <AdminLayout>
            <Box p={4} h="100%" overflow="auto">
                <Card>
                    <CardHeader py={3}> 
                        <Heading size="md" mb={1}>
                            Create Truck
                        </Heading>
                        <Text fontSize="sm" color={colors.text}>
                            Add a new truck to the fleet.
                        </Text>
                    </CardHeader>
                    
                    <CardBody>
                        <TruckForm onSuccess={handleSuccess} onCancel={handleCancel} />
                    </CardBody>
                </Card>
            </Box>
        </AdminLayout>
    );
}
